function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import Vue from "vue";

var _default = /*#__PURE__*/function () {
  function _default() {
    _classCallCheck(this, _default);
  }

  _createClass(_default, null, [{
    key: "saveInitialContent",
    value: function saveInitialContent(content) {
      // History only handles document's scroll position. It doesn't handle our body div's position
      this.bodyScrollTops = []; // This differs from window.history.length in that this only counts internal navigation

      this.navigationCount = 0; // Set initial state so we can go back to it

      window.history.replaceState(this._data(content), "", window.location.href);
    }
  }, {
    key: "_data",
    value: function _data(content) {
      return {
        content: content,
        navigationCount: this.navigationCount
      };
    }
  }, {
    key: "pushPage",
    value: function pushPage(content, url) {
      // Save scroll position of the current page when navigating to the next page
      this.bodyScrollTops[this.navigationCount] = this._pageBody.scrollTop;
      this.navigationCount++; // Save data of the next page (page getting pushed)

      window.history.pushState(this._data(content), "", url);
    }
  }, {
    key: "resetScroll",
    value: function resetScroll() {
      this._pageBody.scrollTop = 0;
    }
  }, {
    key: "restoreOnBackOrForward",
    value: function restoreOnBackOrForward() {
      var _this = this;

      var vm = this;

      window.onpopstate = function (event) {
        // TODO: Ideally display a prompt when dirty
        // if (Utils.http.proceedEvenWhenDirty()) {
        //   event.preventDefault();
        //   history.go(1);
        //   return false;
        // }
        window.vueApp.isFormDirty = false; // Save scroll position of the current page when navigating through back/forward button

        _this.bodyScrollTops[_this.navigationCount] = _this._pageBody.scrollTop;
        var data = event.state;
        data.content.__poppedState = true;
        window.vueApp.page = data.content;
        vm.navigationCount = data.navigationCount;
        Vue.nextTick(function () {
          var scrollTop = _this.bodyScrollTops[_this.navigationCount];
          _this._pageBody.scrollTop = scrollTop;
        });
      };
    }
  }, {
    key: "isPoppedState",
    value: function isPoppedState(page) {
      return page.__poppedState == true;
    }
  }, {
    key: "updatePage",
    value: function updatePage() {
      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.href;
      window.history.replaceState(this._data(window.vueApp.page), "", url);
    }
  }, {
    key: "back",
    value: function back() {
      if (this.navigationCount > 0) {
        window.history.back();
        return true;
      } else {
        console.log("Reached beginning of navigation stack");
        return false;
      }
    }
  }, {
    key: "_pageBody",
    get: function get() {
      return document.getElementById("page_body");
    }
  }, {
    key: "_innerBody",
    get: function get() {
      // TODO: make this support any panelId
      return document.getElementById("inner_body");
    }
  }]);

  return _default;
}();

export { _default as default };